import { defineAsyncComponent } from 'vue'
export default {
  cny: defineAsyncComponent(() => import("/Applications/stvn-git/skjmy-nuxt/src/layouts/cny.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Applications/stvn-git/skjmy-nuxt/src/layouts/default.vue").then(m => m.default || m))
}